/**
 * RemoteDocumentChangeType
 *
 * The kind of change a Firestore live-snapshot delivers for a single document
 * — added, modified, or removed. The string values mirror Firestore's own
 * `DocumentChangeType` literal-union exactly so each callback can pass the
 * library value straight through.
 *
 * This enum lives in the data layer (not under `domain/enums/`) because it is
 * a Firestore-wire detail surfaced by `FirestoreService.subscribe*` callbacks.
 * Every domain wrapper around those callbacks (e.g. `ChatMessageChangeDto`,
 * `UserMediaLiveChange`) consumes this same enum so the literal-union does not
 * have to be re-declared at every call site.
 *
 * Flutter parity: Dart's `DocumentChangeType.added` / `.modified` / `.removed`
 * (`cloud_firestore`).
 */

export enum RemoteDocumentChangeType {
  added = 'added',
  modified = 'modified',
  removed = 'removed',
}
